<template>
	<!-- 新撤单弹框 -->
	<common-modal class="rescind-wrap">
		<div class="modal">
		    <div class="title" v-html="tipObj.title"></div>
		    <p class="rescind-tips" v-html="tipObj.content" :class='tipObj.num==2?"pd-s":""' ref="content"></p>
		    <div class="supply-submit">
				<span class="cancel" @click="onCloseModalClick">取消</span>
				<span class="submit" @click="submitFun(tipObj.num)">确定</span>
			</div>
		</div>
	</common-modal>
</template>

<script>
	import imageUpload from './ImageUpload';
	import CommonModal from './CommonModal';
    export default {
        data(){
            return{
            }
        },
		props:{
			tipObj:{
				type:Object
			}
		},
		
		mounted(){
			if(this.tipObj.num == "1"){//撤单操作
				var anthor = document.getElementById("agree");
				anthor.addEventListener("click",()=>{
					this.showAgreeMent()
				})
			}
		},
        methods:{
			submitFun(num){
				this.$emit("submitFun",num)
			},
			
			onCloseModalClick(){
				this.$emit("close-modal")
			},
			
			showAgreeMent(){
				this.$emit("showAgreeMent")
			}
        },
		components:{
			imageUpload,
			CommonModal
		}
        
    };
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	section{font-family:PingFangSC-Regular;font-weight:400;background:#FFF}
	.modal{width: 320px;background: #fff;margin: 0 auto;padding-bottom: 20px;}
	.title{padding: 12px 20px 0 20px;font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;}

	/* 新撤单弹框 */
	.rescind-tips{padding: 15px 20px 20px 20px;font-size: 14px;font-family: PingFangSC-Regular,PingFang SC;font-weight: 400;color: rgba(102,102,102,1);}
	.pd-s{padding: 15px 10px 20px 16px;}
	.rescind-tips span{color: #4184F4;}
	.rescind-wrap /deep/ .modal{padding-bottom: 0;width: 270px;}
	.supply-submit{display: flex;align-items: center;justify-content: space-between;width: 100%;height: 49px;color: #ffffff;border-top: 1px solid #DDDDDD;}
	.supply-submit .cancel{width: 50%;height:49px;line-height: 49px;font-size: 18px;color: rgba(153,153,153,1);text-align: center;border-right: 1px solid #DDDDDD}
	.supply-submit .submit{width: 50%;height:49px;line-height: 49px;font-size: 18px;font-weight: 500;color: rgba(65,132,244,1);text-align: center;}
</style>
